<template>
    <div
    :class="[
        { disabled },
        'base-color-picker',
    ]"
    >
        <button
            class="color-display"
            @click.prevent="togglePicker"
        >
            <div
                class="color-sample"
                :style="{ 'background-color': colorValue }"
            />
            <span>{{ colorValue }}</span>
        </button>
        <sketch
            v-if="isVisible"
            v-on-clickaway="togglePicker"
            :value="colorValue"
            @input="updateColor"
        />
    </div>
</template>

<script>
import { Sketch } from 'vue-color';
import { mixin as clickaway } from 'vue-clickaway';

export default {
    components: {
        Sketch,
    },

    mixins: [clickaway],

    props: {
        color: {
            type: [String, Boolean],
            required: true,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },

    data: () => ({
        isVisible: false,
    }),

    computed: {
        /**
         *
         * @returns  {string}  Color value
         */
        colorValue() {
            return this.color || '#453F5E';
        },
    },

    methods: {
        /**
         * Hides color picker
         *
         */
        togglePicker() {
            this.isVisible = ! this.isVisible;
        },

        /**
         * Handles color change
         *
         * @param   {object}  data  Color picker data
         *
         */
        updateColor(data) {
            this.$emit('change', data.hex);
        },
    },
};
</script>
